import { toast, type Id, type ToastOptions } from "react-toastify";

export const NOTIFICATION_TOAST_CLASS = "ws-notification-toast";
export const NOTIFICATION_TOAST_BODY_CLASS = "ws-notification-toast__body";

const baseOptions = {
  position: "top-center" as const,
  className: NOTIFICATION_TOAST_CLASS,
  bodyClassName: NOTIFICATION_TOAST_BODY_CLASS,
  type: "default" as const,
  icon: false as const,
  hideProgressBar: false,
};

export type NotificationToastOptions = Omit<
  ToastOptions,
  "type" | "className" | "bodyClassName" | "position" | "icon"
> & {
  link?: string;
  onLinkClick?: (link: string) => void;
};

export function showNotificationToast(
  message: string,
  options: NotificationToastOptions = {}
): Id {
  const { link, onLinkClick, onClick, style, closeOnClick, autoClose, ...rest } =
    options;

  return toast(message, {
    ...rest,
    ...baseOptions,
    autoClose: autoClose ?? 6000,
    closeOnClick: closeOnClick ?? !!link,
    onClick: (event) => {
      onClick?.(event);
      if (link) {
        onLinkClick?.(link);
      }
    },
    style: link ? { cursor: "pointer", ...style } : style,
  });
}
